var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sliceCryptoStr } from './utils.js';
export class BaseCryptoManager {
    constructor() {
        this.encryptLong = (cryptoKey, data, isHex = true) => __awaiter(this, void 0, void 0, function* () {
            if (isHex) {
                data = Buffer.from(data).toString('hex');
            }
            const list = sliceCryptoStr(data, 64);
            const num = list.length;
            let str = '';
            for (let i = 0; i < num; i++) {
                const value = list[i];
                str += yield this.encrypt(cryptoKey, value);
                str += ';';
            }
            if (str.length > 0)
                str = str.slice(0, str.length - 1);
            return str;
        });
        this.decryptLong = (cryptoKey, data, isHex = true) => __awaiter(this, void 0, void 0, function* () {
            const list = data.split(';');
            let str = '';
            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                str += yield this.decrypt(cryptoKey, element);
            }
            if (isHex)
                return Buffer.from(str, 'hex').toString();
            return str;
        });
    }
}
